import { Injectable } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Injectable({ providedIn: 'root' })
export class SvgIllustrationService {
    private cache = new Map<string, SafeHtml>();
    private cacheRaw = new Map<string, string>();

    constructor(private sanitizer: DomSanitizer) {}

    async getSvgIllustration(path: string): Promise<SafeHtml> {
        if (this.cache.has(path)) {
            return this.cache.get(path);
        }

        const response = await fetch(path);
        const rawSvg = await response.text();
        const safeSvg = this.sanitizer.bypassSecurityTrustHtml(rawSvg);

        this.cache.set(path, safeSvg);
        return safeSvg;
    }

    async getSvgIllustrationRaw(path: string): Promise<string> {
        if (this.cacheRaw.has(path)) {
            return this.cacheRaw.get(path);
        }

        const response = await fetch(path);
        const rawSvg = await response.text();

        this.cacheRaw.set(path, rawSvg);
        return rawSvg;
    }
}